var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title || _vm.$t("Message.SendFileVerification"),
        width: "820px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "check-tip" }, [
        _c("img", {
          staticStyle: { "margin-bottom": "15px" },
          attrs: { src: _vm.isPass ? _vm.trueIcon : _vm.falseIcon }
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.matchInstructionTip,
                expression: "matchInstructionTip"
              }
            ]
          },
          [_vm._v(_vm._s(_vm.matchInstructionTip))]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.masterInfo,
                expression: "masterInfo"
              }
            ]
          },
          [_vm._v(_vm._s(_vm.masterInfo))]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.slaveInfo,
                expression: "slaveInfo"
              }
            ]
          },
          [_vm._v(_vm._s(_vm.slaveInfo))]
        ),
        _c(
          "div",
          {
            style: {
              marginTop: "15px",
              marginBottom: _vm.multiFieldSampleError ? "10px" : "",
              fontSize: "16px",
              color: "red",
              height: _vm.multiFieldSampleError ? "" : "0px"
            }
          },
          [_vm._v(_vm._s(_vm.multiFieldSampleError))]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isPass,
                expression: "isPass"
              }
            ]
          },
          [_vm._v(_vm._s(_vm.$t("Message.SendFileVerificationSuccessTip")))]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isPass,
                expression: "!isPass"
              }
            ]
          },
          [_vm._v(_vm._s(_vm.$t("Message.SendFileVerificationExceptionTip")))]
        ),
        _c("div", [_vm._v(_vm._s(_vm.$t("queryJob.ClickFilePrivew")))])
      ]),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.rowData,
            height: 310,
            "span-method": _vm.onSpanMethod
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "no",
              label: _vm.$t("CargoMsg.Cargo_SerialNo"),
              width: "70",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "containerNo",
              label: _vm.$t("SeaExport.ContainerNo"),
              width: "110",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "businessNo",
              label: _vm.$t("SeaExport.BusinessSeq"),
              width: "70",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "jobNo",
              label: _vm.$t("Message.OddNumbers"),
              width: "130",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bliStatus",
              label: _vm.$t("SeaExport.BillLadingIssued"),
              width: "100",
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_c("div", [_vm._v(_vm._s(_vm.getBliStatus(row)))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "info",
              label: _vm.$t("Message.Info"),
              width: "230",
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.fileId &&
                    [
                      "jpg",
                      "png",
                      "jpeg",
                      "gif",
                      "webp",
                      "pdf",
                      "doc",
                      "docx",
                      "xls",
                      "xlsx"
                    ].includes(row.fileType)
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              staticStyle: {
                                "text-decoration": "underline",
                                "text-decoration-color": "blue"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handlePreviewFile(
                                    row.fileId,
                                    row.info + "." + row.fileType
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(row.info))]
                          )
                        ])
                      : _c("div", [_vm._v(_vm._s(row.info))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "isExist",
              label: _vm.$t("Message.Validating"),
              width: "88",
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: row.isExist ? _vm.acceptIcon : _vm.rejectIcon
                        }
                      })
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showNext,
                  expression: "showNext"
                }
              ],
              attrs: { type: "primary" },
              on: { click: _vm.onNext }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Next")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      ),
      _c("pre-view-file-dialog", {
        attrs: {
          "v-if": _vm.previewFileData.visible,
          title: _vm.$t("FileHistory.preview"),
          visible: _vm.previewFileData.visible,
          file: _vm.previewFileData.file,
          "can-maximize": true
        },
        on: { close: _vm.closePreviewDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }